module.exports = __webpack_public_path__ + "img/eletric.d6f6023d.gif";